/**
 * The card beside the Kalendarz tab: what reaches the calendar (calendar-sync-requirements R4).
 * Static — nothing here reads, so it has no wait or error of its own.
 */

import { useTranslation } from 'react-i18next';

import screen from './AccountScreen.module.css';

export function CalendarCard() {
  const { t } = useTranslation();

  return (
    <div className={screen.sidePanel}>
      <div className={screen.card}>
        <h2 className={screen.cardTitle}>{t('web:account.calendar.sideTitle')}</h2>
        <p className={screen.cardBody}>{t('web:account.calendar.scopeNote')}</p>
      </div>
    </div>
  );
}
